/* React */
import React from "react";

/* Minimal-Pie-Chart */
import { PieChart } from "react-minimal-pie-chart";

/* Components */
import ColorLabel from "src/components/charts/chart-legend/color-label/ColorLabel";

/* Stylesheet */
import styles from "./MinimalPieChart.module.scss";

/* Interfaces */
import { LegendProps } from "src/shared/interfaces/charts/Legend";

const MinimalPieChart: React.FC<{
  chartLegendInfo: LegendProps[];
}> = ({ chartLegendInfo }) => {
  const total: number = chartLegendInfo?.reduce(
    (acc: number, item: LegendProps) => acc + item.total,
    0
  );

  return (
    <div className={styles.minimal_pie_chart}>
      <PieChart
        className={styles.pie_chart}
        startAngle={90}
        lineWidth={68}
        data={chartLegendInfo?.map((item) => {
          return {
            value: item.total,
            color: item.color as string,
          };
        })}
      />
      <div className={styles.label_container}>
        {chartLegendInfo?.map(
          (item: LegendProps, index: number) => {
            const percentage: string = (
              (item.total / total) *
              100
            ).toFixed(2);
            return item.total ? (
              <div key={index} className={styles.label}>
                <ColorLabel color={item.color} />
                <div className={styles.percentage}>
                  {percentage}%
                </div>
                <div className={styles.total}>
                  ({item.total})
                </div>
              </div>
            ) : undefined;
          }
        )}
      </div>
    </div>
  );
};

export default MinimalPieChart;
